"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var notifications;
        (function (notifications) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.hasNoticeItems = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    if (!_initArgs.hasNoticeItems) {
                        appn.notifications.updateNotificationTotal(true);
                        appn.notifications.hideNotificationIcon();
                        appn.iframe.closeModal();
                    }
                    addEvents();
                    hideNotificationFooterIfEmpty();
                }
                index.init = init;
                function addEvents() {
                    $('.delete_button').on('click', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        $(this).hide();
                        $(this).closest('.card-tools').find('.select-delete').show();
                        $(this).closest('.card-tools').find('.select-delete input').prop('checked', true);
                        if ($(this).closest('.notification-parent').length > 0) {
                            $(this).closest('.notification-group').find('.select-delete').show();
                            $(this).closest('.notification-group').find('.select-delete input').prop('checked', true);
                            $(this).closest('.notification-group').find('.delete_button').hide();
                        }
                        const notificationGroup = $(this).closest('.notification-group');
                        if (notificationGroup.length > 0) {
                            const selectedCount = notificationGroup.find('.notice .select-delete input:checked').length;
                            const childrenCount = notificationGroup.find('.notification-children .notice').length;
                            if (selectedCount === childrenCount) {
                                const notificationParent = notificationGroup.find('.notification-parent');
                                notificationParent.find('.delete_button').hide();
                                notificationParent.find('.select-delete').show();
                                notificationParent.find('.select-delete input').prop('checked', true);
                            }
                        }
                        updateSelectedCount();
                    });
                    $('.btn-refresh').on('click', function (event) {
                        event.preventDefault();
                        appn.location.reloadCurrentPage();
                    });
                    $('.btn-expand-boxes').on('click', function (event) {
                        event.preventDefault();
                        const iconClass = $('.card-btn-expand-or-collapse i');
                        $('.notification-children').slideDown(0, function () {
                            appn.ui.handleParentResize(0, 0);
                        });
                        iconClass.hasClass('fa-chevron-circle-down') ?
                            iconClass.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up') :
                            iconClass.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
                    });
                    $('.btn-collapse-boxes').on('click', function (event) {
                        event.preventDefault();
                        $('.notification-children').slideUp(0, function () {
                            appn.ui.handleParentResize(0, 0);
                        });
                        const iconClass = $('.card-btn-expand-or-collapse i');
                        iconClass.hasClass('fa-chevron-circle-down') ?
                            iconClass.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up') :
                            iconClass.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
                    });
                    $('.btn-goto').on('click', function (event) {
                        event.preventDefault();
                        window.open($(this).data('link'));
                    });
                    $('.btn-popup').on('click', function (event) {
                        event.preventDefault();
                        appn.ui.popup($(this).data('link'));
                    });
                    $('.dismiss-all').on('click', function (event) {
                        event.preventDefault();
                        $.ajax({
                            headers: appn.verifyHeader,
                            url: appn.urls.notifications.deleteAll,
                            type: 'POST',
                            data: { deleteAll: true },
                            success: function (data, status, xhttp) {
                                parent.appn.notifications.updateNotificationTotal(true);
                                parent.appn.notifications.hideNotificationIcon();
                                appn.iframe.closeModal();
                            },
                            error: function (data, message, message2) {
                                appn.toast.notify(appn.toast.Type.error, T('Delete all notifications failed!'));
                            }
                        });
                    });
                    $('.dismiss-forstatus').on('click', function (event) {
                        event.preventDefault();
                        const noticeStatus = $(this).data('status');
                        $.ajax({
                            headers: appn.verifyHeader,
                            url: appn.urls.notifications.deleteAll,
                            type: 'POST',
                            data: { forstatus: noticeStatus },
                            success: function (data, status, xhttp) {
                                $('.notice.notice-' + noticeStatus).remove();
                                $(this).remove();
                                updateSelectedCount();
                                cleanUpTabsAfterDelete();
                                parent.appn.notifications.updateNotificationTotal(true);
                            }
                        });
                    });
                    $('.btn-downloadFile').on('click', function (event) {
                        event.preventDefault();
                        window.open($(this).data('link'));
                    });
                    $('.select-delete').on('click', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        $(this).closest('.card-tools').find('.delete_button').show();
                        $(this).find('input').prop('checked', false);
                        $(this).hide();
                        const notificationParent = $(this).closest('.notification-group').find('.notification-parent');
                        if (notificationParent.length > 0) {
                            notificationParent.find('.delete_button').show();
                            notificationParent.find('.select-delete input').prop('checked', false);
                            notificationParent.find('.select-delete').hide();
                        }
                        if ($(this).closest('.notification-parent').length > 0) {
                            $(this).closest('.notification-group').find('.notification-children .select-delete input').prop('checked', false);
                            $(this).closest('.notification-group').find('.notification-children .select-delete').hide();
                            $(this).closest('.notification-group').find('.notification-children .delete_button').show();
                        }
                        const tabId = $(this).closest('.tab-pane').attr('id');
                        const $tabSelect = $('.nav-tabs a[href="#' + tabId + '"]').closest('li').find('.tab-select');
                        if (!$(this).prop('checked'))
                            $tabSelect.prop('checked', false);
                        updateSelectedCount();
                    });
                    $('.dismiss-selected').on('click', function (e) {
                        e.preventDefault();
                        let selectedIdsCsv = '';
                        $('.select-delete input:checked').each(function () {
                            const $notice = $(this).closest('.notice');
                            const noticeId = $notice.attr('id');
                            if (noticeId)
                                selectedIdsCsv += noticeId + ',';
                            const notificationGroup = $notice.closest('.notification-group');
                            $notice.remove();
                            notificationGroup.find('.children-count').html(notificationGroup.find('.notification-children .notice').length.toString());
                        });
                        appn.notifications.deleteNotificationsCsv(selectedIdsCsv, cleanUpTabsAfterDelete);
                        updateSelectedCount();
                    });
                    $('.reschedule-selected').on('click', function (e) {
                        e.preventDefault();
                        let selectedIdsCsv = '';
                        $('.select-reschedule input:checked').each(function () {
                            const notice = $(this).closest('.notice');
                            const noticeId = notice.attr('id');
                            if (noticeId)
                                selectedIdsCsv += noticeId + ',';
                            const notificationGroup = notice.closest('.notification-group');
                            notice.remove();
                            notificationGroup.find('.children-count').html(notificationGroup.find('.notification-children .notice').length.toString());
                        });
                        appn.notifications.rescheduleNotificationsCsv(selectedIdsCsv, cleanUpTabsAfterDelete);
                        updateSelectedCount();
                    });
                    $('.reschedule-all').on('click', function (event) {
                        event.preventDefault();
                        $.ajax({
                            headers: appn.verifyHeader,
                            url: appn.urls.notifications.rescheduleAll,
                            type: 'POST',
                            data: { rescheduleAll: true },
                            success: function (data, status, xhttp) {
                                appn.location.reloadCurrentPage();
                            },
                            error: function (data, message, message2) {
                                appn.toast.notify(appn.toast.Type.error, T('Reschedule all notifications failed!'));
                            }
                        });
                    });
                    $('.notification-group .notification-parent .card-title').off();
                    $('.notification-parent').click(function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        const iconClass = $(this).find('.card-btn-expand-or-collapse i');
                        $(this).closest('.notification-group').find('.notification-children').stop().slideToggle(0, function () {
                            appn.ui.handleParentResize(0, 0);
                        });
                        iconClass.hasClass('fa-chevron-circle-down') ?
                            iconClass.removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up') :
                            iconClass.removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
                    });
                    $('.nav-link .appn-checkbox').on('click', function (e) {
                        e.preventDefault();
                        const tabId = $(this).closest('li').find('.nav-link').attr('href');
                        const input = $(this).find('.tab-select');
                        const $allNoticeCheckboxesInCurrentTab = $(tabId + ' .select-delete');
                        const $allNoticeDeleteBtnsInCurrentTab = $(tabId + ' .delete_button');
                        if (!input.prop('checked')) {
                            input.prop('checked', true);
                            $allNoticeDeleteBtnsInCurrentTab.hide();
                            $allNoticeCheckboxesInCurrentTab
                                .show();
                            $allNoticeCheckboxesInCurrentTab
                                .find('input')
                                .prop('checked', true);
                        }
                        else {
                            input.prop('checked', false);
                            $allNoticeDeleteBtnsInCurrentTab.show();
                            $allNoticeCheckboxesInCurrentTab
                                .hide();
                            $allNoticeCheckboxesInCurrentTab
                                .find('input')
                                .prop('checked', false);
                        }
                        updateSelectedCount();
                    });
                    $('.nav-link').on('click', function (e) {
                        const $rescheduleSelectedBtn = $('.reschedule-selected');
                        if ($(this).hasClass('notice-tab-error')) {
                            const rescheduleSelectedCount = $('.select-reschedule input:checked').length;
                            if (rescheduleSelectedCount === 0)
                                $rescheduleSelectedBtn.hide();
                            else
                                $rescheduleSelectedBtn.show();
                        }
                        else {
                            $('.reschedule-selected').hide();
                        }
                    });
                }
                function hideNotificationFooterIfEmpty() {
                    const $footerActionButtonLinks = $('.tab-pane .notice .card-footer .action-buttons');
                    $footerActionButtonLinks.each(function () {
                        if (!$.trim($(this).html()))
                            $(this).closest('.card-footer').hideElement();
                    });
                }
                function updateSelectedCount() {
                    const dismissSelectedBtn = $('.dismiss-selected');
                    const rescheduleSelectedBtn = $('.reschedule-selected');
                    const notices = $('.notice');
                    let totalDelete = 0;
                    let totalReschedule = 0;
                    notices.each((i, o) => {
                        const notice = $(o);
                        const parentClass = notice.parent().attr('class');
                        if (parentClass === appn.emptyString || parentClass === 'notification-children') {
                            totalDelete += notice.find('.select-delete input:checked').length;
                            totalReschedule += notice.find('.select-reschedule input:checked').length;
                        }
                    });
                    dismissSelectedBtn.text(T(' Dismiss ') + totalDelete);
                    dismissSelectedBtn.append('<i class="fa fa-trash ml-2"></i>');
                    if (totalDelete === 0)
                        dismissSelectedBtn.hide();
                    else
                        dismissSelectedBtn.show();
                    rescheduleSelectedBtn.text(T(' Reschedule ') + totalReschedule);
                    rescheduleSelectedBtn.append('<i class="fa fa-calendar ml-2"></i>');
                    if (totalReschedule === 0 || !$('.notice-tab-error').hasClass('active'))
                        rescheduleSelectedBtn.hide();
                    else
                        rescheduleSelectedBtn.show();
                }
                function cleanUpTabsAfterDelete() {
                    if ($('.notice').length === 0) {
                        appn.notifications.hideNotificationIcon();
                        appn.iframe.closeModal();
                        return;
                    }
                    removeEmptyTabs();
                }
                function removeEmptyTabs() {
                    const $tabPanes = $('.tab-pane');
                    if ($tabPanes.length)
                        $tabPanes.each(function (i, pane) {
                            const tabId = $(pane).attr('id');
                            if ($(pane).find('.notice').length === 0) {
                                $('.nav-tabs a[href="#' + tabId + '"]').closest('li').remove();
                                const tabs = $('.nav-tabs li .nav-link');
                                if (appn.utils.hasValue(tabs))
                                    tabs[0].click();
                            }
                        });
                }
            })(index = notifications.index || (notifications.index = {}));
        })(notifications = views.notifications || (views.notifications = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
